/**
 * A marca "Oculto no ERP (TiFlux)" (adendo da spec 039): o ticket é espelhado
 * do TiFlux, de cliente não operado no ERP, e a ocultação do tenant o esconde
 * de toda tela. Na agenda ele aparece com o switch "Mostrar clientes ocultos"
 * (e sempre em "Minha agenda da semana"), com esta marca — e não se abre: o
 * detalhe dele responde 404 para todos. Quem decide se está oculto é a API
 * (`ticketHidden`/`hidden`), nunca a tela.
 */
import { EyeOff } from 'lucide-react';
import { Badge } from '@/components/ui/misc';
import { cn } from '@/lib/utils';

export const HIDDEN_TICKET_LABEL = 'Oculto no ERP (TiFlux)';

export function HiddenTicketBadge() {
  return (
    <Badge title="O ticket não aparece no ERP: só aqui na agenda">
      <EyeOff className="size-3" aria-hidden />
      {HIDDEN_TICKET_LABEL}
    </Badge>
  );
}

/** A marca compacta, para as linhas do calendário: o ícone, com o rótulo no title. */
export function HiddenTicketIcon({ className }: { className?: string }) {
  return (
    <EyeOff
      className={cn('shrink-0 text-muted-foreground', className)}
      role="img"
      aria-label={HIDDEN_TICKET_LABEL}
    >
      <title>{HIDDEN_TICKET_LABEL}</title>
    </EyeOff>
  );
}
